import { DiagnosisModel, IDiagnosisModel } from './DiagnosisModel';
import { ModelRecord } from './Model';
import { ISyncModel, SyncModel } from '@common/models/SyncModel';

export interface IVisitDiagnosisModel extends ISyncModel {
  visitDiagnosisId: number;
  diagnosisId: number;
  visitId: number;
  diagnosis: IDiagnosisModel;
}

export class VisitDiagnosisModel
  extends SyncModel
  implements ModelRecord<IVisitDiagnosisModel>
{
  visitDiagnosisId: number;
  diagnosisId: number;
  visitId: number;
  diagnosis: DiagnosisModel;

  constructor(params: Partial<IVisitDiagnosisModel>) {
    super(params);
    this.visitDiagnosisId = params.visitDiagnosisId ?? 0;
    this.diagnosisId = params.diagnosisId ?? 0;
    this.visitId = params.visitId ?? 0;
    this.diagnosis = new DiagnosisModel(params.diagnosis);
  }
}
